import { removePresenceSubscription } from '../presenceManager/presenceSubscription';
import { removeChat } from '../actions/ucmaActions';
import ChatViewState from '../store/schema/ChatViewState';
import terminateChatSession from '../services/terminateChatSession';

export default function endChat(chat: ChatViewState) {
    terminateChatSession(chat.sessionId).then(() => {
        removeChat(chat);
        removePresenceSubscription(chat.participants);
    });
}
